import axios from 'axios';
import jwtDecode from 'jwt-decode';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(async (config) => {
  let token = localStorage.getItem('token');
  const refreshToken = localStorage.getItem('refreshToken');

  if (isTokenAboutToExpire(token) && refreshToken) {
    try {
      const response = await axios.post(`${process.env.VUE_APP_API_URL}/auth/refresh-token`, { refreshToken });
      token = response.data.accessToken;
      localStorage.setItem('token', token);
    } catch (error) {
      console.error('Erreur lors du rafraîchissement du token :', error);
      throw error;
    }
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

function isTokenAboutToExpire(token) {
  if (!token) return true;
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 - Date.now() < 2 * 60 * 1000; // expire dans moins de 2 minutes
  } catch (e) {
    return true;
  }
}

export default api;
